import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/login/Login";

import ProtectedRoute from "./ProtectedRoute";
import Simulation from "./pages/Simulation/Simulation";
export default function Router() {
    return (
        <Routes>
            {/* Redirige la racine vers le planning (qui renverra vers login si pas de token) */}
            <Route path="/" element={<Navigate to="/Simulation" replace />} />

            <Route path="/login" element={<Login />} />

            <Route
                path="/Simulation"
                element={
                    <ProtectedRoute>
                        <Simulation />
                    </ProtectedRoute>
                }
            />

            {/* Redirige tout le reste vers le planning */}

        </Routes>
    );
}